import $ from "cash-dom";
import StickySidebar from "sticky-sidebar";
export default function () {
  var stickySidebar;

  if ($(".js-annual10k__sticky").length) {
    stickySidebar = new StickySidebar(".js-annual10k__sticky", {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: ".js-annual10k__stickyContainer",
      innerWrapperSelector: ".js-annual10k__stickyInner"
    });
  }

  var $accordions = $(".lf-accordion");

  if ($accordions) {
    $accordions.each(function (_, accordion) {
      var $accordion = $(accordion);
      $(".lf-accordion-toggle", $accordion).each(function (_, toggle) {
        var $toggle = $(toggle);
        var $content = $($toggle.data("contentSelector"));

        if (!$toggle.hasClass("active") && $toggle.find("active").length === 0) {
          $content.css("max-height", 0);
        }

        if ($(".js-annual10k__sticky").length) {
          stickySidebar.updateSticky();
        }

        $(window).on("resize", function () {
          var $content = $($toggle.data("contentSelector"));
          var $children = $content.children();

          if ($toggle.hasClass("active")) {
            $content.css("max-height", Object.values($children).reduce(function (total, selector) {
              return total + $(selector).outerHeight(true);
            }, 0) // Calculates height of the children
            );
          }

          if ($(".js-annual10k__sticky").length) {
            stickySidebar.updateSticky();
          }
        });
        $toggle.on("click", function (e) {
          e.preventDefault();
          $toggle.toggleClass("active");
          var $content = $($toggle.data("contentSelector"));

          if ($content.height() !== 0) {
            $content.css("max-height", 0);
          } else {
            var $children = $content.children();
            delete $children.length; // for summation of height

            $content.css("max-height", Object.values($children).reduce(function (total, selector) {
              return total + $(selector).outerHeight(true);
            }, 0) // Calculates height of the children
            );
          }

          if ($(".js-annual10k__sticky").length) {
            stickySidebar.updateSticky();
          }
        });
      });
    });
  }
}